import React, { PureComponent } from 'react'
import { TableCell, TableRow, Button, MenuItem, FormHelperText, TextField } from '@material-ui/core'
import {
  EditableInput,
  EditableReactSelectCreatable,
  EditableSelect,
  EditableTextField,
} from '../common/EditableComponents'
import { TableCellWithSwitch } from '../common/PureItems'
import EditActionComponent from '../common/EditActionComponent'
import { toCurrencyLocale, toPercentage } from '../../utils/common'
import { hasAccess } from '../../utils/api'
import ModalDialog from '../../components/common/ModalDialog'

export default class FeeItem extends PureComponent {
  onCancel = () => {
    this.props.onCancel()
  }

  onChange = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value

    this.props.onChange(key, value)
  }

  onSave = () => {
    this.props.onSave(() => this.props.disableEdit())
  }

  onChangeZipcodes = (values) => {
    const allZipCodes = values.flatMap((code) =>
      code.value ? code.value.split(',').map((zip) => zip.trim()) : [],
    )
    const uniqueZipCodes = [...new Set(allZipCodes.filter(Boolean))]
    this.props.onChange('zipCodes', uniqueZipCodes)
  }

  onOpenDeleteModal = () => {
    this.confirmDeleteModal.handleClickOpen()
  }

  onConfirmDelete = () => {
    this.confirmDeleteModal.handleClose()
    this.props.onDelete()
  }

  render() {
    const {
      data = {},
      editMode = false,
      config = '',
      cartMinimum = false,
      showFeeType = false,
      activeTab,
      isBLAZEPAY = false,
      isSTRONGHOLD = false,
    } = this.props

    const feeTransformFunction = data.type === 'Percentage' ? toPercentage : toCurrencyLocale
    const permitted = hasAccess()

    const feeNameCharactersCount = (data.feeName ? data.feeName.length : 0).toString() + '/20'
    return (
      <TableRow>
        {showFeeType ? (
          <TableCell>
            <EditableSelect
              editMode={editMode}
              value={data.type || 'Cash'}
              valueToRender={data.type && data.type === 'Cash' ? 'Flat' : data.type || 'Flat'}
              onChange={this.onChange('type')}
            >
              <MenuItem value="Cash">Flat</MenuItem>
              {!isBLAZEPAY && !isSTRONGHOLD ? (
                <MenuItem value="Percentage">Percentage</MenuItem>
              ) : null}
            </EditableSelect>
          </TableCell>
        ) : null}
        {activeTab !== 'DELIVERY' && activeTab !== 'CART_MINIMUM' && (
          <TableCell>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <EditableInput
                type="string"
                value={data.feeName || ''}
                valueToRender={data.feeName || ''}
                editMode={editMode}
                onChange={this.onChange('feeName')}
                inputProps={{
                  maxLength: 20,
                  size: 38,
                }}
              />
              {editMode ? (
                <FormHelperText
                  style={{ color: 'black', top: '5%', right: 0, position: 'absolute' }}
                >
                  {feeNameCharactersCount}
                </FormHelperText>
              ) : (
                ''
              )}
            </div>
          </TableCell>
        )}

        <TableCell>
          <EditableInput
            type="number"
            valueToRender={
              !cartMinimum
                ? feeTransformFunction(data.fee || 0)
                : feeTransformFunction(data.minimum || 0)
            }
            value={!cartMinimum ? data.fee || 0 : data.minimum || 0}
            editMode={editMode}
            onChange={this.onChange(!cartMinimum ? 'fee' : 'minimum')}
          />
        </TableCell>
        {!isBLAZEPAY && !isSTRONGHOLD ? (
          <TableCell>
            {config === 'ZIP_CODE' ? (
              <EditableReactSelectCreatable
                multi={true}
                value={
                  (data.zipCodes &&
                    data.zipCodes.map((zipcode) => ({ label: zipcode, value: zipcode }))) ||
                  []
                }
                onChange={this.onChangeZipcodes}
                valueToRender={
                  (data.zipCodes && data.zipCodes.length && data.zipCodes.join(', ')) || ''
                }
                editMode={editMode}
                options={[]}
                placeholder="Enter Zipcodes"
              />
            ) : (
              <EditableInput
                type="number"
                valueToRender={toCurrencyLocale(data.subTotalThreshold || 0)}
                value={data.subTotalThreshold || 0}
                editMode={editMode}
                onChange={this.onChange('subTotalThreshold')}
              />
            )}
          </TableCell>
        ) : null}

        <TableCellWithSwitch
          data-cy="switch-enabled"
          valueToRender={data.enabled ? 'Enabled' : 'Disabled'}
          checked={data.enabled}
          editMode={editMode}
          onChange={this.onChange('enabled', true)}
        />
        {permitted ? (
          <TableCell style={{ maxWidth: 225, minWidth: 225 }} className="cell-wrap-word">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button
                data-cy="btn-delete-item"
                className="danger-button margin"
                onClick={this.onOpenDeleteModal}
              >
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
        <ModalDialog
          title={`Delete Fee`}
          ref={(c) => (this.confirmDeleteModal = c)}
          onConfirm={this.onConfirmDelete}
          confirmText={'Delete'}
        >
          {`Are you sure you want to delete ${
            activeTab === 'DELIVERY'
              ? 'Delivery'
              : activeTab === 'CART_MINIMUM'
              ? data.feeName || 'Cart Minimum'
              : activeTab === 'CREDIT_CARD'
              ? data.feeName || 'Credit Card'
              : activeTab === 'ACH'
              ? data.feeName || 'ACH'
              : activeTab === 'BLAZEPAY'
              ? data.feeName || 'BLAZEPAY'
              : activeTab === 'STRONGHOLD'
              ? data.feeName || 'Stronghold'
              : data.feeName || 'Cashless ATM'
          } 
                       ${data.feeName ? ' ?' : 'fee ?'}`}
        </ModalDialog>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FeeMinimums/FeeItem.js